<template>
  <div>
  <!-- BARRA SUPERIOR -->
  <v-app-bar app dense flat color="white" elevation="0">
    <v-app-bar-nav-icon
      v-if="!isCliente || !isMobile"
      :color="drawer ? 'grisgrisClaro' : 'azul_med'"
      @click="drawer = !drawer"
    />

    <!-- Logo -->
    <router-link to="/" style="text-decoration: none; color: inherit;">
      <v-toolbar-title class="pa-0">
        <v-img
          src="https://medicover.mx/img/logomedicoverweb.svg"
          contain
          max-width="120"
          max-height="40"
          alt="Logo Medicover"
        />
      </v-toolbar-title>
    </router-link>

    <v-spacer />

    <!-- Menú usuario -->
    <v-menu offset-y rounded min-width="200px">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-avatar size="32">
            <v-icon>mdi-account-circle</v-icon>
          </v-avatar>
          <v-badge v-if="messages > 0" :content="messages" color="green" overlap />
        </v-btn>
      </template>

      <v-card class="pa-3 text-center">
        <v-avatar size="48" class="mb-2">
          <v-icon x-large>mdi-account-circle</v-icon>
        </v-avatar>
        <h4 class="mb-1">{{ getName }}</h4>
        <p v-if="getEmail" class="text-caption grey--text">{{ getEmail }}</p>
        <v-divider class="my-2" />
        <v-btn depressed small text color="error" @click="logout">Cerrar sesión</v-btn>
      </v-card>
    </v-menu>

    <!-- Notificaciones -->
    <v-menu offset-y rounded min-width="200px">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-badge :content="notificaciones.length" :value="notificaciones.length > 0" color="red" overlap>
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          v-for="solicitud in notificaciones"
          :key="solicitud.Id"
          @click="irADetalle(solicitud)"
          class="hoverable"
        >
          <v-list-item-avatar color="blue lighten-4">
            <v-icon color="blue darken-2">mdi-bell</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-body-2">
              {{ solicitud.Mensaje }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption grey--text">
              {{ formatFechaLast(solicitud.fechaCreacion) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="notificaciones.length === 0">
          <v-list-item-content>
            <v-list-item-title class="text--disabled">No hay nuevas solicitudes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>

  <!-- NAV CLIENTE (Bottom en móviles) -->
  <v-bottom-navigation
    v-if="isMobile && isCliente"
    app
    color="primary"
    grow
  >
    <v-btn
      v-for="(item, index) in listMenu[0].Opciones"
      :key="index"
      icon
      @click="$router.push(item.Link)"
    >
      <v-icon small>{{ item.Icono }}</v-icon>
      {{ item.Nombre }}
    </v-btn>
  </v-bottom-navigation>

  <!-- NAV GENERAL (Drawer lateral) -->
  <v-navigation-drawer
    v-else
    dense
    app
    dark
    color="azulfuerte"
    v-model="drawer"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="white--text font-weight-medium text-body-2">
          {{ getName }} {{ getApellidos }}
        </v-list-item-title>
        <v-list-item-subtitle class="grey--text text--caption">Bienvenido</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider />

    <!-- GRUPOS -->
  <v-list dense nav class="py-0">
  <v-list-group
  v-for="(grupo, i) in listMenu"
  :key="i"
  :value="openGroups[i]"
  @update:value="openGroups[i] = $event"
  >
    <!-- Nombre del grupo -->
    <template v-slot:activator>
      <v-list-item-title class="text-uppercase font-weight-bold white--text">
        {{ grupo.Grupo }}
      </v-list-item-title>
    </template>

    <!-- Opciones del grupo -->
<template v-for="(opcion, j) in grupo.Opciones">
  <!-- Si tiene subopciones -->
  <v-list-group
    v-if="opcion.subopciones && opcion.subopciones.length > 0"
    no-action
    sub-group
    :key="'opcion-' + j"
    :value="subOpen[i + '_' + j]"
    @update:value="subOpen[i + '_' + j] = $event"
  >
    <template v-slot:activator>
      <v-list-item>
        <v-list-item-icon>
          <v-icon small class="mr-2" color="white">
            {{ opcion.Icono || 'mdi-folder' }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ opcion.Nombre }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Subopciones -->
    <v-list-item
      v-for="(sub, k) in opcion.subopciones"
      :key="'sub-' + j + '-' + k"
      :to="sub.SubLink"
      link
      dense
      router
      class="ml-6"
    >
      <v-list-item-icon>
        <v-icon small class="mr-2" color="white">
          {{ sub.SubIcono || 'mdi-circle-small' }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ sub.SubNombre }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-group>

  <!-- Si no tiene subopciones -->
  <v-list-item
    v-else
    :key="'opcion-sin-sub-' + j"
    :to="opcion.Link"
    link
    dense
    router
    class="ml-4 opcion-grupo"
  >
    <v-list-item-icon>
      <v-icon small class="mr-2" color="white">
        {{ opcion.Icono || 'mdi-circle-small' }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ opcion.Nombre }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
  </v-list-group>
</v-list>


    <!-- Footer -->
    <template v-slot:append>
      <v-divider class="mb-2"></v-divider>
      <div class="pa-3">
        <v-btn text block color="red darken-1" small dark @click="logout">
          <v-icon left small>mdi-logout</v-icon>
          Cerrar sesión
        </v-btn>
        <div class="mt-2 text-center grey--text text--caption">
          <v-icon small class="mr-1">mdi-information-outline</v-icon>
          Versión {{ appVersion }}
        </div>
      </div>
    </template>
  </v-navigation-drawer>
</div>
</template>


<script>
import formatFecha from '@/mixins/formatFecha';
import { mapGetters } from 'vuex'
// import * as signalR from '@microsoft/signalr';

export default {
  name: 'HeaderAdm',
  mixins: [formatFecha],
  computed: {
    ...mapGetters(['getName', 'getApellidos', 'isLogged', 'getEmail', 'inRole', 'getMenuOpcions', 'idTarjetaTxt', 'getIDE']),
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.smAndDown;
  this.getMenu().then(() => {
    let found = false; // indicador de que ya encontramos la ruta
    this.listMenu.forEach((grupo, i) => {
      this.$set(this.openGroups, i, false);
      grupo.Opciones?.forEach((opcion, j) => {
        if (opcion.subopciones?.length > 0) {
          this.$set(this.subOpen, `${i}_${j}`, false);
          
          if (!found && opcion.subopciones.some(sub => this.$route.path.includes(sub.SubLink))) {
            this.$set(this.openGroups, i, true);
            this.$set(this.subOpen, `${i}_${j}`, true);
            found = true; // abrimos solo el primero
          }
        }
      });
      // Opciones sin subopciones
      if (!found && grupo.Opciones.some(op => this.$route.path.includes(op.Link))) {
        this.$set(this.openGroups, i, true);
        found = true;
      }
    });
  });

    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('No se encontró token en localStorage');
      return; // opcional: evitar intentar conectar sin token
    }
    /* signal R
        this.connection = new signalR.HubConnectionBuilder()
          .withUrl('https://localhost:7084/notificaciones', {
            accessTokenFactory: () => token
          })
          .configureLogging(signalR.LogLevel.Information)
          .build();
    
        this.connection.start()
          .then(() => {
            console.log('Conectado a SignalR');
    
            this.connection.on('NotificacionVista', (id) => {
              const noti = this.notificaciones.find(n => n.id === id);
              if (noti) {
                this.$set(noti, 'Visto', true); // para reactividad en Vue 2
              }
            });
    
            this.connection.on('RecibirNotificacion', (noti) => {
              this.notificaciones.unshift(noti);
            });
            // También puedes hacer GET inicial de notificaciones si quieres:
            fetch(`https://localhost:7084/api/notificacion/${this.getUsuarioId()}`, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            })
              .then(resp => resp.json())
              .then(data => this.notificaciones = data);
    
          })
          .catch(err => console.error('Error al conectar con SignalR:', err));
      },
    
      beforeDestroy() {
        if (this.connection) {
          this.connection.stop()
            .then(() => console.log('Conexión SignalR detenida'))
            .catch(e => console.error('Error deteniendo conexión SignalR', e));
        }
      */
  },
  created() {
    // this.$store.dispatch('notificaciones/cargarNotificaciones', { usuario: this.getUsuarioId()});
  },
  methods: {

    getUsuarioId() {
      // Asumiendo que guardas el usuario logueado en algún store, token o localStorage
      return this.getIDE
    },
    enviarCorreo() {
      if (this.comentario) {
        var url = `https://wa.me/${process.env.VUE_APP_BASE_PHONEWHATSWEB}?text=${encodeURIComponent()}`;
        window.open(url, '_blank');
      }
    },
    logout() {
      this.$store.dispatch('logout').then(
        () => {
          this.$router.push('/')
        }
      )
    },
    getMenu() {
  return this.$http.get('Menu/Usuario', { user: this.getUsuarioId() })
    .then(response => {
      if (response.status === 200) {
        this.listMenu = response.data;
        this.isCliente = this.listMenu.some(item => item.Grupo === 'Cliente');
      }
    })
    .catch(() => {
      // Manejo de error opcional
    });
    },
    irADetalle(Item) {
      console.log(Item)
    },
    formatFechaLast(valor) {
      if (valor) {
        return this.$dayjs(valor).fromNow(); // Ej: "hace 5 minutos"
      }
    }
  },
  data() {
    return {
      connection: null,
      notificaciones: [],
      openGroups:{},
      subOpen:{},
      appVersion: '10.0.3',
      comentario: '',
      isCliente: false,
      isMobile: false,
      listMenu: {},
      roles: [],
      messages: 0,
      drawer: true,
      admins: [],
      cruds: [],
      items: [
        {
          text: 'Agente',
          icon: 'mdi-account',
          link: 'agente-index'
        },
        {
          text: 'Cotizaciones',
          icon: 'mdi-option',
          link: 'cotizaciones'
          //link: ` /urgencias`
        },
        {
          text: 'Membresias',
          icon: 'mdi-account',
          //link: `${process.env.VUE_APP_BASE_ADMY}/medicover_sesion.html`
          link: `membresias`
        },


      ],
      menu: [
        {
          text: 'COTIZADOR',
          icon: 'mdi-clock',
          link: '/cotizador'
        },
        {
          text: 'MEDICOS Y ESPECIALIDADES',
          icon: 'mdi-account',
          link: '/especialidades-medicas'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
